import shoppingCart from '@/api/shoppingCart';

const state = {
	sampleData: [],
	shoppingCartNum: 0,
}

const mutations = {
	addSampleData: (state, arr) => {
		state.sampleData = arr;
	},
	setShoppingCartNum: (state, num) => {
		state.shoppingCartNum = num;
	},
}

const actions = {
	getShoppingCartList ({ commit }) {
		return new Promise((resolve, reject) => {
			shoppingCart.getShoppingCartList().then(result => {
				commit('setShoppingCartNum', result.data.length);
				resolve(result);
			}).catch(error => {
				reject(error);
			})
		})
	}
};

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
